import React, { useState, useEffect } from "react";
import Alert from "../../components/Alert";
import Breadcrumb from "../../parts/Breadcrumb";
import ListSection from "../../components/ListSection";
import configuration from "../../config";
import { toast } from "react-toastify";
import Loader from "../../components/Loader/Loader";

function View() {
  const columns = [
    {
      title: "ID",
      field: "withdraw_request_id",
    },
    { title: "Amount", field: "amount" },
    { title: "Date", field: "created_at" },
    {
      title: "Status",
      field: "status",
      render: (rowData) => {
        return <span className="capitalize">{rowData.status}</span>;
      },
    },
  ];
  const [data, setData] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const btnGroups = [
    {
      id: 2,
      title: "Add New",
      type: "addNew",
      path: "/withdraw/add",
      fileName: "Withdraw",
    },
  ];
  const [show, setShow] = useState(false);
  // const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    getDatas({});
  }, []);

  function getDatas(filterData) {
    setIsLoader(true);
    configuration
      .getAPI({
        url: "sub-user/withdraw-list",
        params: { filterData: JSON.stringify(filterData) },
      })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          setData(data.payload);
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }

  return (
    <>
      <Breadcrumb module={"Withdraw"} />
      <Loader isOpen={isLoader} />
      <Alert
        show={show}
        setShow={setShow}
        bgColorClass="green"
        caption="Success"
        message="Record added successfully"
      />
      <ListSection
        captionTitle="View Withdraw Request"
        columns={columns}
        data={data}
        btnGroups={btnGroups}
        filters={false}
        disabledCheckbox={true}
      />
    </>
  );
}

export default View;
